import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deploymentsTooltip: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployments-tooltip',
		defaultMessage:
			'{deploymentCount} {deploymentCount, plural, one {deployment} other {deployments}}',
		description:
			'A tooltip which displays the total number of deployments associated to the issue.',
	},
	production: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.production',
		defaultMessage: 'Production',
		description: 'The name of the deployment environment type',
	},
	staging: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.staging',
		defaultMessage: 'Staging',
		description: 'The name of the deployment environment type',
	},
	testing: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.testing',
		defaultMessage: 'Testing',
		description: 'The name of the deployment environment type',
	},
	development: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.development',
		defaultMessage: 'Development',
		description: 'The name of the deployment environment type',
	},
	unmapped: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.unmapped',
		defaultMessage: 'Undefined environment',
		description:
			'The name of the deployment environment type used when the environment is not production, staging, development or testing.',
	},
	pending: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.pending',
		defaultMessage: 'Pending',
		description: 'Text when a deployment status is pending',
	},
	inProgress: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.in-progress',
		defaultMessage: 'In progress',
		description: 'Text when a deployment status is in-progress',
	},
	successful: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.successful',
		defaultMessage: 'Successful',
		description: 'Text when a deployment status is successful',
	},
	failed: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.failed',
		defaultMessage: 'Failed',
		description: 'Text when a deployment status is failed',
	},
	rolledBack: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.rolled-back',
		defaultMessage: 'Rolled back',
		description: 'Text when a deployment status is rolled back',
	},
	cancelled: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.cancelled',
		defaultMessage: 'Canceled',
		description: 'Text when a deployment status is cancelled',
	},
	unknown: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-state.unknown',
		defaultMessage: 'Unknown',
		description: 'Text when a deployment status is unknown',
	},
	deploymentDataAriaLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.delivery.deployment-data.deployment-data-aria-label',
		defaultMessage: '{environmentCategory} deployment {deploymentState}',
		description: 'Aria label for the deployment data button',
	},
});
